import { ILoginRequestDTO } from '@common-frontend-submodule/interfaces/auth/ilogin-request.interface'
import { ILoginResponseDTO } from '@common-frontend-submodule/interfaces/auth/ilogin-response.interface'
import { AuthRoutes } from '@common-frontend-submodule/enums/routes/auth-routes.enum'
import ApiClient from '../../lib/api-client';

const apiClient = ApiClient.getInstance()

export const useAuth = () => {
  const login = async (model: ILoginRequestDTO) => {
    const result = await apiClient.postRequest<ILoginRequestDTO, ILoginResponseDTO>(
      `${AuthRoutes.BasePrefix}/${AuthRoutes.Login}`,
      model
    );
    console.log(result)
    if (result.success) {
      localStorage.setItem('access_token', result.data?.access.accessToken || '');
      localStorage.setItem('refresh_token', result.data?.access.refreshToken || '');
      localStorage.setItem('locale', model.locale || '');
    }
    return result;
  };

  const logout = () => {
    const currentLocale = localStorage.getItem('locale') || 'en';
    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem('locale', currentLocale);
  };

  return {
    login,
    logout
  }
}

